import { useCallback } from "react";

import { formatAmount } from "@/modules/dashboard/crypto-swaps/utils/cryptoSwapFormat";
import useTranslations from "@/shared/lang/useTranslations";

import { truncateDecimals } from "../../utils/cardCopTopUp";

const PRECISION = { COP: 0, USD: 2, USDT: 2 } as const;

export type CopTopUpCurrency = keyof typeof PRECISION;

// Dollars are truncated, not rounded: an estimate of what arrives must never read high.
export function useCopTopUpFormat() {
  const { activeLanguage } = useTranslations("cards");
  return useCallback(
    (value: string | null | undefined, currency: CopTopUpCurrency, withCode = true) => {
      if (!value) return "—";
      const decimals = PRECISION[currency];
      const shown = formatAmount(truncateDecimals(value, decimals), activeLanguage, {
        min: decimals,
        max: decimals,
      });
      return withCode ? `${shown} ${currency}` : shown;
    },
    [activeLanguage],
  );
}
